import React from "react";

import { SidebarItem } from "./SidebarItem";

import {
  TSidebarItem,
  adminSidebarData,
  customerSidebarData,
  otherSideBarData,
} from "@/constants/routes_sidebar/SidebarLinks";

type RenderSidebarRoutesProps = {
  updatedBusinessRoutes: TSidebarItem[];
};

export const RenderSidebarRoutes = ({
  updatedBusinessRoutes,
}: RenderSidebarRoutesProps): React.JSX.Element[] | React.JSX.Element => {
  const subdomain = window.location.hostname.split(".")?.[0];

  if (subdomain === "admin") {
    return adminSidebarData.map((item, index) => (
      <SidebarItem key={index} sideBarData={item} />
    ));
  } else if (subdomain === "customer") {
    return customerSidebarData.map((item, index) => (
      <SidebarItem key={index} sideBarData={item} />
    ));
  } else {
    return (
      <>
        {updatedBusinessRoutes.map((item, index) => (
          <SidebarItem key={index} sideBarData={item} />
        ))}
        <h3 className='p-2 pl-4 text-sm font-medium text-gray-500 3xl:text-base whitespace-nowrap'>
          Others
        </h3>
        {otherSideBarData.map((item, index) => (
          <SidebarItem key={index} sideBarData={item} />
        ))}
      </>
    );
  }
};

export default RenderSidebarRoutes;
